import styled from '@emotion/styled';
import type { HTMLAttributes, Ref } from 'react';
import { forwardRef, memo } from 'react';
import { layoutMaxWidth, layoutPadding } from '../layout/layout-styles';
import { breakpointSmall } from '@/constants/breakpoints';

export const breakpointSmallNoPaddingClass = 'breakpointSmallNoPaddingClass';

const PageSection = styled.section`
  display: flex;
  width: 100%;
  justify-content: center;
`;

const PageDiv = styled.div`
width: 100%;
max-width: ${layoutMaxWidth};
padding: ${layoutPadding};

@media (max-width: ${breakpointSmall}) {
  padding: 0;

  & > *:not(.${breakpointSmallNoPaddingClass}) {
    padding-right: 20px;
    padding-left: 20px;
  }
}

`;

const Page = (
  { children, ...property }: HTMLAttributes<HTMLElement>,
  forwardedRef: Ref<HTMLElement>,
) => (
  <PageSection {...property} ref={forwardedRef}>
    <PageDiv>
      {children}
    </PageDiv>
  </PageSection>
);

export default memo(forwardRef(Page));
